// Generated by Melange

import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__KassaSubheader from "../../../molecules/OrgDashboardHeader/KassaSubheader.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../../molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptsHeader(Props) {
  let id = Props.id;
  let org = Props.org;
  let openMenu = Props.openMenu;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const currentUrlStr = Buhta_cabinet__Route.toString(currentRoute);
  const func = Buhta_cabinet__Kassa.KkmManagerService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$1[1];
  const kkmObj = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  const kkmTitle = typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? "Касса" : kkmObj.VAL.name;
  const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: /* List */ 1
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/back-arrow.svg")
    })
  });
  const newSaleButton = JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: {
          TAG: /* Kkm */ 0,
          _0: id,
          _1: /* Cashbox */ 4
        }
      }
    }),
    className: "bg-links hover:bg-links-hover active:bg-links-active flex rounded-sm px-3 py-2",
    children: [
      JsxRuntime.jsx("img", {
        src: StaticAsset.src("/static/icons/plus.svg")
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "ml-1 text-white",
        children: "Новая продажа"
      })
    ],
    urlParams: {
      hd: [
        "return_to",
        currentUrlStr
      ],
      tl: /* [] */ 0
    }
  });
  const subheader = typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? null : JsxRuntime.jsx(Buhta_cabinet__KassaSubheader.make, {
      currentRoute: currentRoute,
      kkm: kkmObj.VAL,
      contextRoute: contextRoute
    });
  return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
    title: kkmTitle,
    leftChildren: backButton,
    openMenu: openMenu,
    rightChildren: newSaleButton,
    subheader: subheader
  });
}

const make = ReceiptsHeader;

export {
  make,
}
/* Buhta_cabinet__Kassa Not a pure module */
